export default "__VITE_ASSET__CyYshTcE__"